import { Component, OnInit, ViewChild } from '@angular/core';
import { UserManagmentService } from '../user-managment.service';
import { ErrorHandler } from '@root/utils/error-handler.service';
import { ToastrService } from 'ngx-toastr';
import { Role } from './../roles.model';
import { SelectionModel } from '@angular/cdk/collections';
import { MatCheckboxChange } from '@angular/material';
import { NgForm } from '@angular/forms'; 
import { DependentFeatures , DependentFeaturesByKey } from '@common/common.constant';
@Component({
  selector: 'app-add-roles',
  templateUrl: './add-roles.component.html',
  styleUrls: ['./add-roles.component.scss'],
  providers: [UserManagmentService],
})
export class AddRolesComponent implements OnInit {

  @ViewChild('f', { static: false }) form: NgForm;

  accessList = [];

  accessListMap = {};

  featureSelection = new SelectionModel(true, []);

  roleList: any[];

  roleObj = new Role();

  isSelectAll = false;

  parentFeatures: string[] =[];

  childFeatures ={};

  dependentFeatures:{[key:string] :string} ={};

  parentFeatureToggleMap:{[key:string] :string} = {};

  constructor(public userManagmentService: UserManagmentService,
              private errorHandler: ErrorHandler,
              private toastr: ToastrService) {
                this.dependentFeatures = DependentFeatures;
                this.childFeatures = DependentFeaturesByKey;
  }

  ngOnInit() {
    this.parentFeatures = Object.getOwnPropertyNames(DependentFeaturesByKey);
    this.readAccessList();
  }
  

  public readAccessList() {
    const obj = {};
    this.userManagmentService.readAccessList(obj).subscribe(
      (response) => {
        if(response.status === 0) {
          this.accessList = response.data.feature || [];
          this.accessList.forEach(f => {
            this.accessListMap[f.featureName] =  f;
          })
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

  public processForm() {
    const features = this.featureSelection.selected.map( f => f.featureId);
    this.roleObj.features = features.toString();
    
    this.userManagmentService.createOrUpdateRole(this.roleObj).subscribe(
      response => {
        if(response.status === 0){
          this.toastr.success(response.message);
          this.readRoles();
        }
        this.resetForm();
        this.errorHandler.handleError(response);
      },
      error => {
        this.errorHandler.handleError(error);
      }
    )
  }

  public readRoles(){
    const obj = {};
    this.userManagmentService.getRoleList(obj).subscribe(
      (response) => {
        if (response.status === 0) {
          this.roleList = response.data.list;
        }
        this.errorHandler.handleError(response);
      },
      (error) => {
        this.errorHandler.handleError(error);
      }
    );
  }

    /***
   * Name position validation
   */
  keyPressAlpha(event: any) {
    const pattern = /[a-zA-Z0-9 ]/;

    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  public onSelectAllTags() {
    this.accessList.forEach((feature) => this.featureSelection.select(feature));
  }

  public onClearTags() {
    this.featureSelection.clear();
  }

  public onSelectAllChange(change: MatCheckboxChange){
    change.checked ? this.onSelectAllTags() : this.onClearTags();
  }

  public onParentFeatureChange(change: MatCheckboxChange, feature:string){
    if(change.checked){
      this.parentFeatureToggleMap[feature] = feature
    } else {
      delete this.parentFeatureToggleMap[feature];
    }
  }
  
  public isParentFeatureSelected(feature:string):boolean{
    const features =  Object.getOwnPropertyNames(this.childFeatures[feature])||[];
    let isSelected = true;
    for(const _f of features){
        const feature = this.accessListMap[_f];
        if(feature && !this.featureSelection.isSelected(feature)){
          isSelected= false;
          break;
        }
    }
    return  isSelected;
  }

  public resetForm(){
    this.roleObj = new Role();
    this.featureSelection.clear();
    this.isSelectAll = false;
    this.form.resetForm();
  }

  public onRoleEdit(role: any) {
    this.resetForm();
    if(role){
      this.roleObj.roleId = role.id;
      this.roleObj.role = role.name;
      for(const f of role.feature ){
        this.featureSelection.select(this.accessListMap[f.fName])
      }
      this.isSelectAll = this.featureSelection.selected.length === this.accessList.length;
      for(const pfeature  of  this.parentFeatures ){
       this.parentFeatureToggleMap[pfeature] = pfeature;
      }
    }
  }

  public toggleParentFeature(key:string){
   
  }
}
